import React, { useContext, useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import '../../css/Commission.css';
import Spinner from "../loading/spinner";
import SidebarContext from "../sidebarcontext/SidebarContext";




export default function TermView() {
    const { customStyles, loading, setTermList, termList, termSearch } = useContext(SidebarContext);





    const searchInput = useRef("");

    const columns = [
        {
            name: "S.N.",
            width: "63px",
            center: true,
            cell: (row, index) => index + 1,
        },
        {
            name: "Term",
            // center: true,
            // grow: 0,
            selector: (row) => row.TermName,
        },
        {
            name: "Exam Date",
            selector: (row) => row.ExamDate,
        },
        {
            name: "Result Date",
            selector: (row) => row.ExamResultDate,
        },
        {
            name: "Working Days",
            // grow: 0,
            width: "120px",
            selector: (row) => row.WorkingDays,
        }

    ];





    const searchHandler = (e) => {
        e.preventDefault();

        const srchQuery = searchInput.current.value.toLowerCase();
        if (srchQuery) {

            let srchResult = termSearch.filter((list) => {
                return list["TermName"].toLowerCase().includes(srchQuery);
            });

            if (srchResult) {

                setTermList(srchResult);
            } else {
                setTermList({});
            }
        } else {
            setTermList(termSearch);
        }
    };

    return (


        <>
            <div className="sec-dataTable">

                {loading ? (
                    <Spinner />
                ) : (
                    <DataTable
                        columns={columns}
                        data={termList}
                        customStyles={customStyles}
                        pagination
                        fixedHeader
                        fixedHeaderScrollHeight="280px"
                        highlightOnHover
                        pointerOnHover
                        responsive
                        dense
                        striped
                        subHeader
                        subHeaderAlign="left"
                        subHeaderComponent={
                            <>
                                <div className="col-lg-2 offset-lg-10 offset-md-10 offset-sm-0 col-md-2 col-sm-2 align-self-end Search" style={{ paddingRight: "1px", marginBottom: "10px" }}>
                                    <div className="d-flex">
                                        <input
                                            placeholder="Search"
                                            ref={searchInput}
                                            type="text"
                                            className="form-control form-control-sm searchField"
                                            onChange={searchHandler}
                                        />
                                    </div>
                                </div>
                            </>
                        }
                    />
                )}
            </div>
        </>
    );
}
